/* eslint-disable */
/**
 * Filtering utilities for Product Dashboard
 * 
 * Provides functions to filter SRs by search query.
 */

import { ProductTimelineItem } from '../types/productDashboard';

/**
 * Filter SRs by search query
 * 
 * Searches across SR key, title, and area fields (case-insensitive).
 * 
 * @param items - Array of ProductTimelineItem to filter
 * @param query - Search query string
 * @returns Filtered array of ProductTimelineItem
 */
export function filterSRs(items: ProductTimelineItem[], query: string): ProductTimelineItem[] {
  const trimmedQuery = query.trim();
  
  if (!trimmedQuery) {
    return items; // No filter applied
  }

  const lowerQuery = trimmedQuery.toLowerCase();

  return items.filter(
    (item) =>
      item.sr_key.toLowerCase().includes(lowerQuery) ||
      item.sr_title.toLowerCase().includes(lowerQuery) ||
      item.sr_area.some((area) => area.toLowerCase().includes(lowerQuery))
  );
}
